import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Box, Button, Container, FormHelperText, TextField, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import RtlProvider from '../../../Components/RtlProvider';
import { ContextNotification, severitys } from '../../../App';
import colorApi from '../../../api/colorApi';
import helper from '../../../helper';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import BeatLoading from '../../../Components/Loader/BeatLoader';

const AddColor = () => {
  const { open, setOpen } = useContext(ContextNotification);
  const [PlanCodeKeys, setPlanCodeKeys] = useState([])
  const [submitLoading, setSubmitLoading] = useState(false);
  const navigate = useNavigate();
  const schema = yup.object().shape({
    planCodeKey: yup.string().required("کد پلان را انتخاب نمایید"),
    colorCode: yup.string().required("کد رنگ را انتخاب نمایید")
  });
  const { register, handleSubmit, formState: { errors }, control } = useForm({
    resolver: yupResolver(schema),
  });
  const onSubmit = (data) => {
    setSubmitLoading(true);
    colorApi.Add(data).then((res) => {
      if (res.data.success) {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
        navigate("/dashboard/ColorPanel");
      }
      else {
        setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
      }
    }).catch(err => {
      if (err.response) {
        setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
      }
    }
    ).finally(() => { setSubmitLoading(false); });
  };

  useEffect(() => {
    GetUnUsePlanCodeKeys();
  }, []);
  const GetUnUsePlanCodeKeys = () => {
    colorApi.Filter(2)
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        setPlanCodeKeys(arr.map((item) => {
          return {
            id: item.key,
            label: item.value
          };
        }))


      })
      .catch((n) => console.log(n));
  };
  const handlePlanCodeKeyChanged = (id) => { };
  return (
    <Container component="main" maxWidth="xs">
      <form onSubmit={handleSubmit(onSubmit)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>
            اختصاص رنگ به کد پلان
          </Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <RHFAutocomplete
              control={control}
              options={PlanCodeKeys ?? []}
              name="planCodeKey"
              placeholder="کد پلان"
              onChange={handlePlanCodeKeyChanged}
              style={{
                border: "none",
                padding: 0,
              }}
              error={!!errors?.planCodeKey}
              helperText={errors?.planCodeKey?.message}
            />
            <TextField id="outlined-basic" variant="outlined" {...register("colorName")} fullWidth label="نام رنگ" />
            <input type="color" {...register("colorCode")} />
            <FormHelperText error={!!errors?.colorCode}>{errors.colorCode?.message}</FormHelperText>
          </Box>
          <Button type="submit" variant="contained" color="secondary" disabled={submitLoading}><BeatLoading loading={submitLoading} color={"#e65100"} size={8} />افزودن</Button>
        </RtlProvider>
      </form>
    </Container>
  )
}
export default AddColor;